import ButtonIconH from "../components/ButtonIconH";
import DataTable from "react-data-table-component";
import InputData from "../components/InputData";
import DropdownFilter from "../components/DropdownFilter";
import CheckBox from "../components/CheckBox";
import InputIconSearchPanelMultiSelection from "../components/InputIconSearchPanelMultiSelection";
import Tag from "../components/Tag";
import { Invoice } from "../components/Invoice";
import { TabSelector } from "../components/TabSelector";
import { useState, useEffect } from "react";
import {
  inputOnEnter,
  formatValueUnit,
  focusElement,
  userData,
  invoicesSearchStructure,
} from "../js/utils";
import { useSuppliers } from "../hooks/useSuppliers";
import moment from "moment";
import { dueDateColumns, invoiceColumns } from "../js/tableColumns";
import { post } from "../js/post";
import "../css/InvoicePanel.css";

export function InvoicePanel({
  show,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [searchData, setSearchData] = useState(invoicesSearchStructure);
  const [supplierList, refreshSuppliers] = useSuppliers("", "", "");
  const [selectedSuppliersList, setSelectedSuppliersList] = useState([]);
  const [invoicesList, setInvoicesList] = useState([]);
  const [invoicesListFixed, setInvoicesListFixed] = useState([]);
  const [dueDateList, setDueDateList] = useState([]);
  const [dueDateListFixed, setDueDateListFixed] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectedOp, setSelectedOp] = useState("Facturas");
  const [handleInvoice, setHandleInvoice] = useState(false);
  const [invoiceID, setInvoiceID] = useState(null);

  const conditionalRowStyles = [
    {
      when: (row) => row.pagado,
      style: {
        backgroundColor: "#ffdfbbff",
      },
    },
  ];

  function resetFilters() {
    setSearchData(invoicesSearchStructure);
    setSelectedSuppliersList([]);
  }

  async function getInvoicesList(start) {
    const response = await post(
      "support-extra/facturasAlbaranes/ListarFacturasAlbaranes.php",
      {
        token: userData.token,
        ...searchData,
      },
    );
    setTotal(response.total);
    if (start === 0) {
      setInvoicesList(response.facturas);
      setInvoicesListFixed(response.facturas);
    } else {
      setInvoicesList([...invoicesList, ...response.facturas]);
      setInvoicesListFixed([...invoicesList, ...response.facturas]);
    }
  }

  async function getDueDateList(start) {
    const response = await post(
      "support-extra/facturasAlbaranes/ListarFacturasVencimientos.php",
      {
        token: userData.token,
        ...searchData,
      },
    );
    setTotal(response.total);
    if (start === 0) {
      setDueDateList(response.vencimientos);
      setDueDateListFixed(response.vencimientos);
    } else {
      setDueDateList([...dueDateList, ...response.vencimientos]);
      setDueDateListFixed([...response.vencimientos, ...dueDateList]);
    }
  }

  useEffect(() => {
    const selectedIDs = supplierList
      .filter((e) => selectedSuppliersList.includes(e.nombre))
      .map((e) => e.id);
    setSearchData((prev) => ({
      ...prev,
      proveedores: selectedIDs,
    }));
  }, [selectedSuppliersList]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (selectedOp === "Facturas") getInvoicesList(searchData.start);
      else getDueDateList(searchData.start);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchData, selectedOp]);

  useEffect(() => {
    if (show === true) {
      focusElement(1);
      refreshSuppliers("", "", "");
    }
  }, [show]);

  if (!show) {
    return <></>;
  }

  return (
    <div className="patient-data">
      {handleInvoice && (
        <Invoice
          id={invoiceID}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onClose={async () => {
            setSearchData((prev) => ({
              ...prev,
              start: 0,
            }));
            setHandleInvoice(false);
            setInvoiceID(null);
          }}
        />
      )}
      <div className="patient-data-header">
        <span className="header-text">Facturas</span>
        <div className="patient-header-buttons"></div>
      </div>
      <div className="patient-data-content store-data-content invoice-content">
        <div className="action-bar">
          <div className="action-bar-resume">
            <span>Almacén</span>
            <span>|</span>
            <span className="signed-text">Facturas</span>
          </div>
        </div>
        <div className="patient-info store-info">
          <div
            className="opt-table-title"
            style={{ justifyContent: "space-between" }}
          >
            <span>Búsqueda de facturas</span>
            <button className="cell-label" onClick={resetFilters} tabIndex={-1}>
              Limpiar filtros
            </button>
          </div>
          <div className="opt-table-content grid-8" id="invoices-filters-grid">
            <div className="cell cell-start-content data-field">
              <span className="label">Nº factura</span>
            </div>
            <div className="cell">
              <InputData
                tabIndex={1}
                type="type-alphanum-ext"
                size={0}
                input={searchData.nFactura}
                onChange={(e) => {
                  setSearchData((prev) => ({
                    ...prev,
                    nFactura: e,
                  }));
                }}
              ></InputData>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha desde</span>
            </div>
            <div className="cell">
              <input
                type="date"
                max="9999-12-31"
                tabIndex={3}
                className="input-field input-cell w-100"
                value={searchData.fechaDesde}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchData((prev) => ({
                    ...prev,
                    fechaDesde: value ? moment(value).format("YYYY-MM-DD") : "",
                  }));
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Pendiente</span>
            </div>
            <div className="cell">
              <CheckBox
                tabIndex={5}
                active={searchData.pendiente}
                onClick={() => {
                  setSearchData((prev) => ({
                    ...prev,
                    pendiente: !prev.pendiente,
                    pagado: !prev.pendiente ? false : prev.pagado,
                  }));
                }}
              ></CheckBox>
            </div>
            <div className="cell cell-start-content data-field">
              <span className="label">Proveedores</span>
            </div>
            <div className="cell">
              <InputIconSearchPanelMultiSelection
                size={0}
                tabIndex={2}
                type={"type-alphanum-ext"}
                options={supplierList.map((e) => e.nombre)}
                selectedOptions={selectedSuppliersList}
                onChange={(e) => {
                  setSelectedSuppliersList(e);
                }}
              ></InputIconSearchPanelMultiSelection>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha hasta</span>
            </div>
            <div className="cell">
              <input
                type="date"
                max="9999-12-31"
                tabIndex={4}
                className="input-field input-cell w-100"
                value={searchData.fechaHasta}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchData((prev) => ({
                    ...prev,
                    fechaHasta: value ? moment(value).format("YYYY-MM-DD") : "",
                  }));
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Pagado</span>
            </div>
            <div className="cell">
              <CheckBox
                tabIndex={6}
                active={searchData.pagado}
                onClick={() => {
                  setSearchData((prev) => ({
                    ...prev,
                    pagado: !prev.pagado,
                    pendiente: !prev.pagado ? false : prev.pendiente,
                  }));
                }}
              ></CheckBox>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: "100%",
              gap: 10,
            }}
          >
            {selectedSuppliersList.length > 0 && (
              <span style={{ fontWeight: "500", fontSize: 13 }}>
                Proveedores seleccionados: {selectedSuppliersList.length}
              </span>
            )}
            <div className="tag-content">
              {selectedSuppliersList.map((e, i) => {
                return (
                  <Tag
                    text={e}
                    key={i}
                    tagId={i}
                    onClick={(e) => {
                      setSelectedSuppliersList((prev) =>
                        prev.filter((sup) => sup !== e),
                      );
                    }}
                  ></Tag>
                );
              })}
            </div>
          </div>
        </div>
        <div
          className="patient-info"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            marginBottom: 20,
          }}
        >
          <TabSelector
            options={["Facturas", "Vencimientos"]}
            style={{ borderBottom: "none" }}
            selected={selectedOp}
            onChange={(e) => {
              setSelectedOp(e);
            }}
          />
          <div className="thin-section-rounded-border">
            {selectedOp === "Facturas" && (
              <>
                <div className="opt-table-title opt-table-title-button">
                  <div>
                    Listado de facturas (
                    {formatValueUnit(invoicesListFixed.length)} de{" "}
                    <span style={{ color: "#41b3ff" }}>
                      {formatValueUnit(total)}
                    </span>
                    )
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 30 }}
                  >
                    <DropdownFilter
                      disabled={false}
                      optionList={[
                        {
                          id: "00",
                          text: "25",
                          active: searchData.total === 25,
                        },
                        {
                          id: "01",
                          text: "50",
                          active: searchData.total === 50,
                        },
                        {
                          id: "02",
                          text: "100",
                          active: searchData.total === 100,
                        },
                      ]}
                      op={"Mostrando " + searchData.total}
                      selectedOptions={[]}
                      onChange={(e) => {
                        setSearchData((prev) => ({
                          ...prev,
                          start: 0,
                          total: parseInt(e.text),
                        }));
                      }}
                    ></DropdownFilter>
                    <ButtonIconH
                      text="Nueva factura"
                      highlight={true}
                      small={true}
                      onClick={async () => {
                        setInvoiceID(-1);
                        setHandleInvoice(true);
                      }}
                    ></ButtonIconH>
                  </div>
                </div>
                <div
                  className="store-products-table delivery-note-table"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  <DataTable
                    columns={invoiceColumns}
                    data={invoicesListFixed}
                    className="custom-datatable"
                    conditionalRowStyles={conditionalRowStyles}
                    noDataComponent="No hay facturas disponibles."
                    onRowClicked={(row, event) => {
                      setInvoiceID(parseInt(row.idFacturaAlbaran));
                      setHandleInvoice(true);
                    }}
                  />
                  <ButtonIconH
                    text="Ver más"
                    small={true}
                    onClick={() => {
                      setSearchData((prev) => ({
                        ...prev,
                        start: prev.start + prev.total,
                      }));
                    }}
                  ></ButtonIconH>
                </div>
              </>
            )}
            {selectedOp === "Vencimientos" && (
              <>
                <div className="opt-table-title opt-table-title-button">
                  <div>
                    Listado de vencimientos (
                    {formatValueUnit(dueDateListFixed.length)} de{" "}
                    <span style={{ color: "#41b3ff" }}>
                      {formatValueUnit(total)}
                    </span>
                    )
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 30 }}
                  >
                    <DropdownFilter
                      disabled={false}
                      optionList={[
                        {
                          id: "00",
                          text: "25",
                          active: searchData.total === 25,
                        },
                        {
                          id: "01",
                          text: "50",
                          active: searchData.total === 50,
                        },
                        {
                          id: "02",
                          text: "100",
                          active: searchData.total === 100,
                        },
                      ]}
                      op={"Mostrando " + searchData.total}
                      selectedOptions={[]}
                      onChange={(e) => {
                        setSearchData((prev) => ({
                          ...prev,
                          start: 0,
                          total: parseInt(e.text),
                        }));
                      }}
                    ></DropdownFilter>
                    <ButtonIconH
                      text="Nueva factura"
                      highlight={true}
                      small={true}
                      onClick={async () => {
                        setInvoiceID(-1);
                        setHandleInvoice(true);
                      }}
                    ></ButtonIconH>
                  </div>
                </div>
                <div
                  className="store-products-table delivery-note-table"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  <DataTable
                    columns={dueDateColumns}
                    data={dueDateListFixed}
                    className="custom-datatable"
                    conditionalRowStyles={conditionalRowStyles}
                    noDataComponent="No hay vencimientos disponibles."
                    onRowClicked={(row, event) => {
                      setInvoiceID(parseInt(row.idFacturaAlbaran));
                      setHandleInvoice(true);
                    }}
                  />
                  <ButtonIconH
                    text="Ver más"
                    small={true}
                    onClick={() => {
                      setSearchData((prev) => ({
                        ...prev,
                        start: prev.start + prev.total,
                      }));
                    }}
                  ></ButtonIconH>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
